module.exports = __webpack_public_path__ + "static/Testimonial_Michael_Angerer-567b44299a43dc56c4de6d58b6efefcf.png";